<template>
  <v-list nav>
    <v-list-item link to="/">
      <v-list-item-icon>
        <v-icon :color="colors.SidebarIconsColor">mdi-home-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Αρχική Σελίδα</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/buildings" link>
      <v-list-item-icon>
        <v-icon :color="colors.SidebarIconsColor">mdi-domain</v-icon>
      </v-list-item-icon>
      <v-list-item-content >
        <v-list-item-title> Κτήρια</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/lifts" link>
      <v-list-item-icon>
        <wnl-unit-icon :color="colors.SidebarIconsColor"></wnl-unit-icon>
      </v-list-item-icon>
      <v-list-item-content >
        <v-list-item-title> <wnl-text>Ανυψωτικά</wnl-text>  </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link v-if="userDetails.Allows.ShowCallouts" to="/history">
      <v-list-item-icon>
        <v-icon :color="colors.SidebarIconsColor">mdi-history</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Ιστορικό Εργασιών</v-list-item-title>
        <v-list-item-subtitle> βλάβες, συντηρήσεις, εργασίες</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-group
        v-if="userDetails.Allows.ShowDepts || userDetails.Allows.ShowDeptsMoves"
        :color="colors.SidebarIconsColor"
        value="true"
        prepend-icon="mdi-cash">

      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Οικονομικά</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item class="ml-5" link v-if="userDetails.Allows.ShowDepts" to="/financial/dept">
        <v-list-item-icon>
          <v-icon :color="colors.SidebarIconsColor">mdi-cash-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Εκκρεμότητες
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="ml-5" link v-if="userDetails.Allows.ShowDeptsMoves" to="/financial/deptMoves">
        <v-list-item-icon>
          <v-icon :color="colors.SidebarIconsColor">mdi-compare-horizontal</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Αναλυτικές Κινήσεις
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>


    <v-list-item link to="/issues" v-if="userDetails.Allows.AddIssues">
      <v-list-item-icon>
        <v-icon :color="colors.SidebarIconsColor">mdi-email</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Αιτήματα</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link to="/user">
      <v-list-item-icon>
        <v-icon :color="colors.SidebarIconsColor">mdi-account</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Στοιχεία Χρήστη</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>
import {mapGetters} from 'vuex'
import WnlText from "@/wl-unit-text/WnlText";
import WnlUnitIcon from "@/wl-unit-text/WnlUnitIcon";

export default {
  name: "SidebarMenu",
  components: {WnlUnitIcon, WnlText },
  computed: {
    ...mapGetters([
      "userDetails",
      "colors"
    ]),

  }
}
</script>

<style scoped>

</style>
